module.exports = __webpack_public_path__ + "img/box_pro_two_8.e0b73018.jpg";